import { CATEGORY_POPULAR_SLUG } from "@views/HomePage/constants/category";
import { GameCategoryModel, GameProviderModel, GameStatus, GetGameListRequest } from "kz-ui-sdk";

export const ITEMS_PER_PAGE = 21;
export const initialGameQuery: GetGameListRequest["query"] = {
  limit: ITEMS_PER_PAGE,
  offset: 0,
  status: GameStatus.Active,
};

export const buildFilterQueries = (
  defaults: GetGameListRequest["query"],
  filters?: { category?: Pick<GameCategoryModel, "id" | "slug">; provider?: Pick<GameProviderModel, "id"> },
): GetGameListRequest["query"] => {
  let provider = filters?.provider?.id;
  const category = filters?.category?.id;
  let sortCategory = undefined;

  // If category is recent or popular, set provider to undefined
  if (filters?.category?.slug && CATEGORY_POPULAR_SLUG.includes(filters?.category?.slug)) {
    provider = undefined;
  }

  // If category is popular, should sort games by category
  if (filters?.category?.slug === CATEGORY_POPULAR_SLUG) {
    sortCategory = true;
  }

  return {
    ...defaults,
    provider,
    category,
    sortCategory,
  };
};
